import { baseResources, baseResourceActions } from "routes/enum";

const {
    KB_DEPENDENCY,
    KB_DEPENDENCY_TOGGLE,
    KB_SAM_BRANCH,
    KB_DOWNTIME_COLLECTION,
} = baseResources;

const { READ, CREATE, UPDATE, DELETE } = baseResourceActions;

/** View dependency */
export const DEPENDENCY_READ_PERMISSION = [`${READ}_${KB_DEPENDENCY}`];

/** Add new dependency */
export const DEPENDENCY_CREATE_PERMISSION = [`${CREATE}_${KB_DEPENDENCY}`];

/** Turn dependency on/off */
export const DEPENDENCY_TOGGLE_PERMISSION = [
    `${UPDATE}_${KB_DEPENDENCY_TOGGLE}`,
];

/** Edit dependency */
export const DEPENDENCY_UPDATE_PERMISSION = [`${UPDATE}_${KB_DEPENDENCY}`];

/** Delete dependency */
export const DEPENDENCY_DELETE_PERMISSION = [`${DELETE}_${KB_DEPENDENCY}`];

/** Add branches (downtime, sub-downtime, uptime) */
export const BRANCH_CREATE_PERMISSION = [`${CREATE}_${KB_SAM_BRANCH}`];

/** Edit branches (downtime, sub-downtime, uptime) */
export const BRANCH_UPDATE_PERMISSION = [`${UPDATE}_${KB_SAM_BRANCH}`];

/** Add general downtime collection */
export const DOWNTIME_COLLECTION_CREATE_PERMISSION = [
    `${CREATE}_${KB_DOWNTIME_COLLECTION}`,
];

/** Edit general downtime collection */
export const DOWNTIME_COLLECTION_UPDATE_PERMISSION = [
    `${UPDATE}_${KB_DOWNTIME_COLLECTION}`,
];

export const DEPENDENCY_BRANCH_UPDATE_PERMISSION = [
    ...BRANCH_UPDATE_PERMISSION,
    ...DOWNTIME_COLLECTION_UPDATE_PERMISSION,
];

export const DEPENDENCY_BRANCH_CREATE_PERMISSION = [
    ...BRANCH_CREATE_PERMISSION,
    ...DOWNTIME_COLLECTION_CREATE_PERMISSION,
];

export const DEPENDENCY_PERMISSION_MAP = {
    "View dependency": DEPENDENCY_READ_PERMISSION,
    "Add new dependency": DEPENDENCY_CREATE_PERMISSION,
    "Turn dependency on/off": DEPENDENCY_TOGGLE_PERMISSION,
    "Edit dependency": DEPENDENCY_UPDATE_PERMISSION,
    "Delete dependency": DEPENDENCY_DELETE_PERMISSION,
    "Add branches (downtime, sub-downtime, uptime)": BRANCH_CREATE_PERMISSION,
    "Edit branches (downtime, sub-downtime, uptime)":
        BRANCH_UPDATE_PERMISSION,
    "Add general downtime collection": DOWNTIME_COLLECTION_CREATE_PERMISSION,
    "Edit general downtime collection": DOWNTIME_COLLECTION_UPDATE_PERMISSION,
};
